import { ProductInventoryDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { observeProductInventories } from 'src/utils/firebase/firebase-short-cut';

const useProductInventoriesForSupplier = (supplierId: string | undefined) => {
  const [isLoading, setIsLoading] = useState(true);
  const [productInventories, setProductInventories] = useState<ProductInventoryDoc[]>([]);

  useEffect(() => {
    const productInventory$ = observeProductInventories(
      supplierId
        ? [
            ['purchaseConfig.supplierId', '==', supplierId],
            ['active', '==', true],
          ]
        : undefined
    );

    const subscription = productInventory$.subscribe((inventories0) => {
      const inventories = inventories0
        .sort((a, b) => a.inventoryName.localeCompare(b.inventoryName))
        .filter((inventory) => inventory.deletedAt === null);
      setProductInventories(inventories);
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, [supplierId]);

  return { productInventories, isLoading };
};

export default useProductInventoriesForSupplier;
